module.exports = __webpack_public_path__ + "static/rafli-a23867cb80a83311e0c902c40e92f1ff.svg";